/**
 * @fileoverview gRPC-Web generated client stub for help_request
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.3
// source: api/dashboard/v2/help_request_service.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var api_dashboard_v2_improvement_message_pb = require('../../../api/dashboard/v2/improvement_message_pb.js')

var api_dashboard_v2_users_message_pb = require('../../../api/dashboard/v2/users_message_pb.js')

var api_dashboard_v2_job_role_message_pb = require('../../../api/dashboard/v2/job_role_message_pb.js')

var api_dashboard_v2_department_message_pb = require('../../../api/dashboard/v2/department_message_pb.js')

var api_dashboard_v2_user_note_message_pb = require('../../../api/dashboard/v2/user_note_message_pb.js')
const proto = {};
proto.help_request = require('./help_request_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.help_request.HelpServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.help_request.HelpServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.help_request.HelpRequest,
 *   !proto.help_request.HelpResponse>}
 */
const methodDescriptor_HelpService_GetUser = new grpc.web.MethodDescriptor(
  '/help_request.HelpService/GetUser',
  grpc.web.MethodType.UNARY,
  proto.help_request.HelpRequest,
  proto.help_request.HelpResponse,
  /**
   * @param {!proto.help_request.HelpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.help_request.HelpResponse.deserializeBinary
);


/**
 * @param {!proto.help_request.HelpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.help_request.HelpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.help_request.HelpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.help_request.HelpServiceClient.prototype.getUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/help_request.HelpService/GetUser',
      request,
      metadata || {},
      methodDescriptor_HelpService_GetUser,
      callback);
};


/**
 * @param {!proto.help_request.HelpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.help_request.HelpResponse>}
 *     Promise that resolves to the response
 */
proto.help_request.HelpServicePromiseClient.prototype.getUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/help_request.HelpService/GetUser',
      request,
      metadata || {},
      methodDescriptor_HelpService_GetUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.help_request.ChangeStatusRequest,
 *   !proto.help_request.HelpResponse>}
 */
const methodDescriptor_HelpService_ChangeStatusHelpRequest = new grpc.web.MethodDescriptor(
  '/help_request.HelpService/ChangeStatusHelpRequest',
  grpc.web.MethodType.UNARY,
  proto.help_request.ChangeStatusRequest,
  proto.help_request.HelpResponse,
  /**
   * @param {!proto.help_request.ChangeStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.help_request.HelpResponse.deserializeBinary
);


/**
 * @param {!proto.help_request.ChangeStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.help_request.HelpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.help_request.HelpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.help_request.HelpServiceClient.prototype.changeStatusHelpRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/help_request.HelpService/ChangeStatusHelpRequest',
      request,
      metadata || {},
      methodDescriptor_HelpService_ChangeStatusHelpRequest,
      callback);
};


/**
 * @param {!proto.help_request.ChangeStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.help_request.HelpResponse>}
 *     Promise that resolves to the response
 */
proto.help_request.HelpServicePromiseClient.prototype.changeStatusHelpRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/help_request.HelpService/ChangeStatusHelpRequest',
      request,
      metadata || {},
      methodDescriptor_HelpService_ChangeStatusHelpRequest);
};


module.exports = proto.help_request;

